<section class="background-color-nearwhite">
    <div class="container">
        <a class="underlined-link back" da-link [routerLink]="linkAccountCourseList"
            ><span [innerHTML]="'booking.bookingDetails.backToMyCourses' | translate"></span
        ></a>
        <h1 [innerHTML]="'booking.bookingDetails.title' | translate"></h1>
        <p class="large" [innerHTML]="'booking.bookingDetails.intro' | translate"></p>
        <div class="one-columns" *ngIf="bookingDetails$ | async as bookingDetails; else loader">
            <div>
                <h3 [innerHTML]="'booking.bookingDetails.bookingTitle' | translate"></h3>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.courseNumber' | translate"></label>
                    <span>{{ bookingDetails.externalCourseNumber }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.courseTitle' | translate"></label>
                    <span>{{ courseTitle }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.status' | translate"></label>
                    <span *ngIf ="(status$ | async) === 'BOOKED'" [innerHTML]="'courses.status.booked' | translate"></span>
                    <span *ngIf ="(status$ | async) === 'PASSED'" [innerHTML]="'courses.status.passed' | translate"></span>
                    <span *ngIf ="(status$ | async) === 'OFFEN'" [innerHTML]="'courses.status.open' | translate"></span>
                    <span *ngIf ="(status$ | async) === 'WAITINGLIST'" [innerHTML]="'courses.status.waitinglist' | translate"></span>
                    <span *ngIf ="(status$ | async) === 'PROVISIONAL'" [innerHTML]="'courses.status.provisional' | translate"></span>
                    <span *ngIf ="(status$ | async) === 'CANCELLED'" [innerHTML]="'courses.status.cancelled' | translate"></span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.bookingDate' | translate"></label>
                    <span>{{ bookingDetails.bookingDate | date: (dateFormat$ | async) }} </span>
                </div>
            </div>
            <div></div>
        </div>
    </div>
</section>
<section class="background-color-white">
    <div class="container two-columns">
        <div class="" *ngIf="bookingPerson$ | async as bookingPerson">
            <h3 [innerHTML]="'booking.bookingDetails.bookingContact' | translate"></h3>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.salutation' | translate"></label>
                <span>{{ translatedBookingSalutation$ | async }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.userTitle' | translate"></label>
                <span>{{ bookingPerson.title }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.name' | translate"></label>
                <span>{{ bookingPerson.firstName }} {{ bookingPerson.lastName }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.phone' | translate"></label>
                <span>{{ bookingPerson.phone }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.department' | translate"></label>
                <span>{{ bookingPerson.department }}</span>
            </div>
            <br />
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.company' | translate"></label>
                <span>{{ bookingPerson.company }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.street' | translate"></label>
                <span>{{ bookingPerson.address }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.city' | translate"></label>
                <span>{{ bookingPerson.city }}</span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.zipCode' | translate"></label>
                <span>{{ bookingPerson.zipCode }} </span>
            </div>
            <div class="group">
                <label [innerHTML]="'booking.bookingDetails.country' | translate"></label>
                <span>{{ translatedBookingCountry$ | async }}</span>
            </div>
        </div>
        <ng-container>
            <div class="billing-contact" *ngIf="billingPerson$ | async as billingPerson">
                <h3 [innerHTML]="'booking.bookingDetails.billingContact' | translate"></h3>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.salutation' | translate"></label>
                    <span>{{ translatedBillingSalutation$ | async }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.userTitle' | translate"></label>
                    <span>{{ billingPerson.title }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.name' | translate"></label>
                    <span>{{ billingPerson.firstName }} {{ billingPerson.lastName }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.phone' | translate"></label>
                    <span>{{ billingPerson.phone }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.department' | translate"></label>
                    <span>{{ billingPerson.department }}</span>
                </div>
                <br />
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.company' | translate"></label>
                    <span>{{ billingPerson.company }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.street' | translate"></label>
                    <span>{{ billingPerson.address }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.city' | translate"></label>
                    <span>{{ billingPerson.city }}</span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.zipCode' | translate"></label>
                    <span>{{ billingPerson.zipCode }} </span>
                </div>
                <div class="group">
                    <label [innerHTML]="'booking.bookingDetails.country' | translate"></label>
                    <span>{{ translatedBillingCountry$ | async }}</span>
                </div>
            </div>
        </ng-container>
    </div>
</section>
<section class="background-color-nearwhite">
    <div class="container">
        <p [innerHTML]="'booking.bookingDetails.edit' | translate"></p>
    </div>
</section>
<ng-template #loader>
    <section>
        <div id="loader-screen" class="drg-loading-container">
            <i class="loading-icon"></i>
            <i class="loader-shadow"></i>
        </div>
    </section>
</ng-template>
